import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import SharedPopUp from "@componentsShared/BottomSheetPopup__OLD/SharedPopUp";
import stl from "./FuelEco.module.css";
import { Icon } from "@syarahtech/ui";
import useBoolean from "@hooks/useBoolean";
var FuelEco = function FuelEco(_ref) {
  var fuelEco = _ref.fuelEco;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var popup = useBoolean();
  var listOfLevel = Object.values(fuelEco.list_of_level);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "border-t border-[#ebeeee] border-solid px-0 py-3 w-full md:w-[calc(50%-12.5px)]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-2"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/local_gas_station.svg",
    alt: "fuel consumption",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex md:items-center md:gap-1 w-full"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-gray-text text-sm font-regular"
  }, t("استهلاك الوقود:", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1"
  }, /*#__PURE__*/React.createElement("span", {
    className: "flex items-center gap-1"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-gray-text text-sm font-bold"
  }, fuelEco.fuel_economy), /*#__PURE__*/React.createElement("span", {
    className: "text-gray-text text-sm font-regular"
  }, t("(كم/لتر)", {
    ns: "web_post_view"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "hover:opacity-60 transition duration-200 cursor-pointer flex items-center",
    onClick: popup.setTrue
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--info-outline-rounded",
    width: 4,
    height: 4,
    className: "text-gray-text"
  })))))), /*#__PURE__*/React.createElement(SharedPopUp, {
    show: popup.value,
    onClose: popup.setFalse
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.EcoPopUpContent
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.flexBet
  }, /*#__PURE__*/React.createElement("strong", null, t("اقتصاد الوقود", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("strong", null, fuelEco.fuel_economy, /*#__PURE__*/React.createElement("span", null, t("(كم/لتر)", {
    ns: "web_post_view"
  })))), /*#__PURE__*/React.createElement("div", {
    className: stl.flexBet
  }, /*#__PURE__*/React.createElement("strong", null, t("نوع الوقود", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("strong", null, fuelEco.fuel_type)), /*#__PURE__*/React.createElement("div", {
    className: [stl.ecoBoxLines, fuelEco.level_class.replace(" ", "")].join(" ")
  }, listOfLevel.map(function (item, i) {
    return /*#__PURE__*/React.createElement("div", {
      className: stl.showEcoCard,
      key: i
    }, /*#__PURE__*/React.createElement("div", {
      className: stl.singleEcoRow
    }, /*#__PURE__*/React.createElement("span", null, item.ar), /*#__PURE__*/React.createElement("span", null, item.en)), /*#__PURE__*/React.createElement("div", {
      className: stl.singleEcoRow
    }, fuelEco.level_id === item.id ? fuelEco.fuel_economy : ""));
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.flexCent
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/rrr.png",
    alt: ""
  })))));
};
export default FuelEco;